import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  ContentSection,
  ContentSectionHeading,
  ContentSectionWrapper,
  Image,
} from 'shared/SectionControl/NewSectionModal/components/ModalContent/pages/style'

import ButtonSectionImage from '../../assets/ButtonSection/button-section.png'

export const ButtonPage = () => {
  const { t } = useTranslation()

  return (
    <ContentSectionWrapper>
      <ContentSectionHeading>{t('Feedback section')}</ContentSectionHeading>
      <ContentSection>
        <Image alt="" src={ButtonSectionImage} />
      </ContentSection>
    </ContentSectionWrapper>
  )
}
